/**
 * Zeitleiste der Version 4 „Der Mensch hinter dem Lebenslauf“.
 * Gleiches Prinzip wie in v3/beats.js: Stationen als Bereiche auf --l,
 * Animationen relativ dazu über `inB` und `atB`.
 */

export const BEATS = [
  { id: 'intro', label: 'Start', at: [0, 0.04] },
  {
    id: 'ohne',
    label: 'Ohne Aivy',
    at: [0.04, 0.25],
    text: 'So lief es bisher. Mara prüft jede Bewerbung gründlich, doch Lebensläufe zeigen Stationen, keine Stärken. Der Neue überzeugt auf dem Papier, passt aber nicht ins Team, und kurz darauf ist der Platz wieder frei.'
  },
  {
    id: 'rewind',
    label: 'Zurückspulen',
    at: [0.25, 0.3],
    text: 'Eine Fehlbesetzung kostet Zeit, Geld und Nerven. Also spulen wir zurück.'
  },
  {
    id: 'anforderung',
    label: 'Die Anforderungen',
    at: [0.3, 0.39],
    text: 'Diesmal definieren die Fachbereiche zuerst selbst, was die Stelle braucht. Aivy macht daraus ein Anforderungsprofil. Hier vereinfacht als Silhouette über dem freien Platz.'
  },
  {
    id: 'menschen',
    label: 'Aus Lebensläufen werden Menschen',
    at: [0.39, 0.5],
    text: 'Aus jeder Bewerbung wird ein Mensch. Im Game-based Assessment zeigt jede Person ihre Stärken, statt nur einen Lebenslauf zu schicken.'
  },
  {
    id: 'regeln',
    label: 'Gleiche Regeln für alle',
    at: [0.5, 0.59],
    text: 'Aivy gleicht alle nach denselben festen Regeln mit dem Anforderungsprofil ab. Keine Blackbox, jede Passung bleibt nachvollziehbar.'
  },
  {
    id: 'shortlist',
    label: 'Die Shortlist',
    at: [0.59, 0.67],
    text: 'Die drei passendsten Personen für Customer Success treten vor. Mara hat für jede ein ausführliches Passungsprofil.'
  },
  {
    id: 'kreuz',
    label: 'Kreuzmatching',
    at: [0.67, 0.74],
    text: 'Jonas passt nicht ins Customer Success, aber perfekt in den Vertrieb. Dank Kreuzmatching geht dieses Talent nicht verloren.'
  },
  {
    id: 'einstellung',
    label: 'Die Einstellung',
    at: [0.74, 0.84],
    text: 'Lena kommt ins Gespräch, mit Interviewfragen aus ihrem Passungsprofil. Es passt, und diesmal bleibt der Platz besetzt.'
  },
  {
    id: 'fair',
    label: 'Fair für alle',
    at: [0.84, 0.92],
    text: 'Und alle anderen? Gehen mit ihrem persönlichen Stärkenprofil. Bewertet nach denselben Kriterien, fair und nachvollziehbar.'
  },
  { id: 'finale', label: 'Der Vergleich', at: [0.92, 1] }
]

const B = Object.fromEntries(BEATS.map((b) => [b.id, b.at]))

export const inB = (beat, a, b) => {
  const [s, e] = B[beat]
  const len = e - s
  return [s + a * len, s + b * len]
}

export const atB = (beat, a) => inB(beat, a, a)[0]
